import "semantic-ui-css/semantic.min.css";
import "./styles/index.css";
import "./utility/filepondPolyfill";
import "./utility/mhStringMethods";

import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
